import { agentWsClient } from '@libs/websocket-client';
import type { StreamEvent, ThreadMessages, ThreadSummary } from '../models';
import { AgentChatError, normalizeStreamEvent } from '../models';

export type { StreamEvent, ThreadMessages, ThreadSummary };
export { AgentChatError };

export async function sendMessageWebSocket(
  params: {
    message: string;
    companyCode: string;
    jobContext: Record<string, unknown> | null;
    threadId?: string;
    approvalDecision?: {
      approvalId: string;
      decision: string;
      reason?: string;
      editMessage?: string;
    } | null;
  },
  onEvent: (event: StreamEvent) => void,
  signal?: AbortSignal,
): Promise<void> {
  return agentWsClient.sendAndStream(
    {
      action: 'sendMessage',
      message: params.message,
      companyCode: params.companyCode,
      jobContext: params.jobContext ?? null,
      threadId: params.threadId || '',
      approvalDecision: params.approvalDecision ?? null,
    },
    (raw) => onEvent(normalizeStreamEvent(raw)),
    { signal },
  );
}

export function listThreads(): Promise<{ threads: ThreadSummary[] }> {
  return agentWsClient.sendAndReceive({ action: 'listThreads' });
}

export function getThread(threadId: string): Promise<ThreadMessages> {
  return agentWsClient.sendAndReceive({ action: 'getThread', threadId });
}

export function deleteThread(threadId: string): Promise<{ threadId: string }> {
  return agentWsClient.sendAndReceive({ action: 'deleteThread', threadId });
}
